class ZipPayWrapper extends HTMLElement {
  constructor() {
    super();

    this.onlyGiveX = Boolean(this.dataset.onlyGiveX);
    this.cartTotalPrice = Number(this.dataset.cartTotalPrice);

    // Show Quadpay Widget - ZipPay 3rd party integration
    if (this.cartTotalPrice >= 35 && this.cartTotalPrice <= 1600 && !this.onlyGiveX) {
      this.style.display = 'block';
    } else {
      this.style.display = 'none';
    }
  }
}

export default ZipPayWrapper;
